const $ = jQuery;

export default class SocialMetricsHelper {
	constructor() {
		this.refresh_ig_btn = $("#cs-refresh-ig-followers");
		this.refresh_tt_btn = $("#cs-refresh-tt-followers");
		this.refresh_ig_er_btn = $("#cs-refresh-ig-er");
		this.refresh_ugc_btn = $("#cs-refresh-ugc-followers");
		this.ig_followers_field = $('#form-field-ig_followers');
		this.tt_followers_field = $('#form-field-tt_followers');
		this.ig_er_field = $('#form-field-ig_er');
		this.ugc_followers_field = $('#ucg-calculator-followers-section input#form-field-followers');
	}

	bindEvents = () => {
		this.refresh_ig_btn.on("click", this.refresh_ig_followers);
		this.refresh_tt_btn.on("click", this.refresh_tt_followers);
		this.refresh_ig_er_btn.on("click", this.refresh_ig_er);
		this.refresh_ugc_btn.on("click", this.refresh_ugc_followers);
	};

	fetch_followers = (platform) => {
		switch (platform) {
			case 'ig':
				this.ig_followers_field.attr("readonly", true);
				break;
			case 'tt':
				this.tt_followers_field.attr("readonly", true);
				break;
			case 'ig_er':
				this.ig_er_field.attr("readonly", true);
				break;
			case 'ugc':
				this.ugc_followers_field.attr("readonly", true);
				break;
		}

		$.ajax({
			url: CSWP.ajax_url,
			method: "POST",
			dataType: "json",
			data: {
				network: platform,
				action: "cs_sf_refresh_follower_count",
				_ajax_nonce: CSWP.nonce,
			},
			success: (response) => {
				if (response.success) {
					let count = response.data.count;
					switch (platform) {
						case 'ig':
							this.ig_followers_field.val(parseInt(count));
							break;
						case 'tt':
							this.tt_followers_field.val(parseInt(count));
							break;
						case 'ig_er':
							this.ig_er_field.val(parseInt(count));
							break;
						case 'ugc':
							this.ugc_followers_field.val(parseInt(count));
							break;
					}
					if (platform !== 'ugc') {
						cSCalculatorSubmit();
					} else {
						cSCalculatorContentSubmit();
					}
				} else {
					console.log("Error refreshing followers: internal error");
				}
				this.hideLoaders(platform);
			},
			error: (jqXHR, textStatus, errorThrown) => {
				console.log(`Error refreshing followers: ${errorThrown}`);
				this.hideLoaders(platform);
			},
		});
	}

	refresh_ig_followers = () => {
		$('.ig_followers_input_wrap').find('.reload-loader').show();
		this.fetch_followers('ig');
	};

	refresh_tt_followers = (event) => {
		$('.tt_followers_input_wrap').find('.reload-loader').show();
		this.fetch_followers('tt');
	};

	refresh_ig_er = (event) => {
		$('.ig_er_input_wrap').find('.reload-loader').show();
		this.fetch_followers('ig_er');
	};

	refresh_ugc_followers = (event) => {
		$('.ugc_followers_input_wrap').find('.reload-loader').show();
		this.fetch_followers('ugc');
	}

	hideLoaders = (platform) => {
		switch (platform) {
			case 'ig':
				$('.ig_followers_input_wrap').find('.reload-loader').hide();
				break;
			case 'tt':
				$('.tt_followers_input_wrap').find('.reload-loader').hide();
				break;
			case 'ig_er':
				$('.ig_er_input_wrap').find('.reload-loader').hide();
				break;
			case 'ugc':
				$('.ugc_followers_input_wrap').find('.reload-loader').hide();
				break;
		}
	}
}
